import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import { withRouter } from 'src/helpers';

import LeftDetail from './LeftDetail';
import CenterDetail from './CenterDetail';
import RightDetail from './RightDetail';
import model from './model';

class DoctorDetail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    let username = this.props.router.params.username;
    model.loadDetail(username, (err, data) => {
      if (!err) {
        model.getAvailableSlots(data.id);
      } else {
        this.navigate('/');
      }
    });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  render() {
    let { booked } = model.getState();
    const doctor = model.getDoctor();
    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__body mc-doctor-detail-page'}>
          <LeftDetail detail={doctor} />
          <CenterDetail detail={doctor} booked={booked} />
          <RightDetail detail={doctor} />
        </div>
      </div>
    );
  }
}

export default withRouter(DoctorDetail);
